import { useFormik } from 'formik';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import Select from 'react-select';
import { Form } from 'react-bootstrap'; // أضف Button
import { useTranslation } from 'react-i18next';
import useGetPersons from '@hooks/HR/use-get-persons';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { useNavigate, useParams } from 'react-router-dom';
import {
  addInventoryCountEntries,
  getEnteriesListByInventoryCountId
} from '@store/INV/InventoryCount/inventoryCountSlice';
import { getPersonId } from '@store/Login/authSelectors';
import CountLine from './CountLine';
import { useMemo } from 'react';
import { Card, CardBody, CardHeader } from '@components/card/card';

const AddEntries = ({ onClose }: any) => {
  const { invCountId } = useParams();
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const Navigate = useNavigate();
  const { dataEmployees, loading } = useGetPersons();
  const personId = useAppSelector(getPersonId);

  //#region Formik
  const formik = useFormik({
    initialValues: {
      invCountId: invCountId,
      personId: personId,
      entryDate: new Date().toISOString().split('T')[0],
      inventoryCountEntriesLineList: []
    },

    enableReinitialize: true,
    onSubmit: values => {
      dispatch(
        addInventoryCountEntries({
          invCountId: values.invCountId,
          personId: values.personId,
          entryDate: values.entryDate,
          inventoryCountEntriesLineList: values.inventoryCountEntriesLineList.map((m: any) => ({
            invCountItemsId: m.invCountItemsId,
            countQuantity: m.countQuantity,
            unitOfMeasure: m.unitOfMeasure,
            description: m.itemName
          }))
        })
      )
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Add' });
            dispatch(getEnteriesListByInventoryCountId(invCountId || '  '));
            onClose();
          } else {
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => formik.setSubmitting(false));
    }
  });

  const { values, handleChange, errors, touched, isSubmitting } = formik;
  //#endregion

  // إحصائيات البنود المضافة
  const totalStats = useMemo(() => {
    const totalItems = values.inventoryCountEntriesLineList?.length || 0;
    const totalQuantity =
      values.inventoryCountEntriesLineList?.reduce((sum: number, item: any) => sum + (item.countQuantity || 0), 0) || 0;

    return { totalItems, totalQuantity };
  }, [values.inventoryCountEntriesLineList]);

  return (
    <>
      <Card className=' '>
        <CardHeader className='d-flex justify-content-between align-items-center'>
          <h5 className='mb-0'>
            <i className='fas fa-plus-circle me-2'></i>
            {t('إضافة إدخالات جرد')}
            <span className='badge bg-theme ms-2'>{t('جديد')}</span>
          </h5>
          <div>
            <span className='badge bg-success me-2'>
              {t('عدد البنود')}: {totalStats.totalItems}
            </span>
            <span className='badge bg-info'>
              {t('الإجمالي')}: {totalStats.totalQuantity.toLocaleString()}
            </span>
          </div>
        </CardHeader>

        <CardBody className='p-0'>
          <div>
            {/* معلومات الأساسية */}
            <div className='p-3 border-bottom bg-secondary bg-opacity-45'>
              <div className='row g-3'>
                <div className='col-md-6'>
                  <div className='form-group mb-0'>
                    <label className='form-label fw-bold'>{t('الموظف')}</label>
                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isLoading={loading}
                      isSearchable={true}
                      isClearable
                      name='personId'
                      options={dataEmployees}
                      value={dataEmployees?.find((f: any) => f.value === values.personId)}
                      onChange={(option: any) => {
                        formik.setFieldValue('personId', option === null ? null : option.value);
                      }}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='form-group mb-0'>
                    <label className='form-label fw-bold'>{t('تاريخ الإدخال')}</label>
                    <Form.Control
                      className='form-control text-center'
                      type='date'
                      name='entryDate'
                      onChange={handleChange}
                      value={values.entryDate || ''}
                    />
                    <div className='text-danger small mt-1'>{formik.touched.entryDate && formik.errors.entryDate}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* إضافة البنود */}
            <div className='p-3 border-bottom'>
              <CountLine formik={formik} />
            </div>
          </div>
        </CardBody>

        <div className='card-footer d-flex justify-content-between align-items-center'>
          <div className='text-muted small'>
            {t('عدد البنود المضافة')}: {totalStats.totalItems} | {t('إجمالي الكميات')}:{' '}
            {totalStats.totalQuantity.toLocaleString()}
          </div>
          <div className='text-theme fw-bold'>
            <div className='p-0'>
              <button
                disabled={isSubmitting || totalStats.totalItems === 0}
                type='submit'
                className='btn me-2 btn-theme'
                onClick={e => {
                  e.preventDefault();
                  formik.handleSubmit();
                }}
              >
                {isSubmitting ? (
                  <>
                    <div className='spinner-border spinner-border-sm me-2'></div>
                    {t('جاري الحفظ...')}
                  </>
                ) : (
                  <>
                    <i className='fas fa-save me-2'></i>
                    {t('حفظ الإدخالات')}
                  </>
                )}
              </button>
              <button type='button' className='btn btn-outline-secondary' onClick={onClose}>
                <i className='fas fa-times me-2'></i>
                {t('إلغاء')}
              </button>
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};
export default AddEntries;
